export default __webpack_public_path__ + "static/media/arrow-back-small.4f06438e.svg";